export default __webpack_public_path__ + "static/media/WNo.7-2.526c1c9b.jpg";